import styled from "styled-components";

export const MainDiv = styled.div`
  background-color: ${(props) => props.theme.colors.bgColorLight};
`;